import { render, staticRenderFns } from "./base.vue?vue&type=template&id=93a70e8e&"
import script from "./base.vue?vue&type=script&lang=ts&"
export * from "./base.vue?vue&type=script&lang=ts&"
import style0 from "./base.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports